import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  GetCountry,
  ActiveCountry,
  InactiveCountry,
} from "../../../store/country-store/country-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";

const CountryDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const country = useSelector((state) => state.country.country);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (country.id === undefined || country.id === 0) {
      dispatch(GetCountry(param.countryId, userInfo.Email));
    }
  }, [param.countryId, dispatch, country.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(ActiveCountry(param.countryId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveCountry(param.countryId, userInfo.Email));
  };
  let activeSuspend;
  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("country.active")
  ) {
    activeSuspend = (
      <div className="field col-12 md:col-3">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "150px" }}
          label="Activar"
          className="p-button-success"
          onClick={activeHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-check"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }
  if (country.status) {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("country.inactive")
    ) {
      activeSuspend = (
        <div className="field col-12 md:col-3">
          <Button
            rounded
            text
            raised
            style={{ backgroundColor: "#fff", width: "150px" }}
            label="Suspender"
            className="p-button-warning"
            onClick={inactiveHandler}
            icon={
              notification && notification.status === "pending"
                ? "pi pi-spin pi-spinner"
                : "pi pi-times"
            }
            disabled={notification && notification.status === "pending"}
          />
        </div>
      );
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(country.id === undefined || country.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(country.id !== undefined || country.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
            }}
          >
            <div
              className="user-info text-center"
              style={{ borderBottom: "solid #fff", paddingBottom: "1.3%" }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {country.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                país
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12">
                <>
                  <label
                    style={{ color: "", fontSize: "large", fontWeight: "bold" }}
                  >
                    Código:{" "}
                  </label>
                  <label
                    style={{
                      color: "",
                      marginLeft: "1%",
                      fontSize: "large",
                    }}
                  >
                    {" "}
                    {"\n" + country.code + "\n"}
                  </label>
                </>
              </div>
              <div className="field col-12 md:col-3 ">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/country");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("country.edit") && (
                  <div className="field col-12 md:col-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{ backgroundColor: "#fff", width: "150px" }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/country/edit/${country.id}`);
                      }}
                    />
                  </div>
                )}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default CountryDetail;
